import { get } from "./base";

export const getParticipantsOverview = (study) => get(`/participants/study/${study}`);
